export default __webpack_public_path__ + "static/media/frLogo.b0508c46.png";